import React from 'react';

import { Save } from '@mui/icons-material';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { useFormikContext } from 'formik';

import DeleteWithConfirmation from './DeleteWithConfirmation';

const ActionsButtons = ({ remove }) => {
  const { isSubmitting } = useFormikContext();

  return (
    <Grid container justifyContent='flex-end'>
      <Box mb={1}>
        <Button type='submit' disabled={isSubmitting} variant='contained' color='primary'>
          {isSubmitting ? <CircularProgress size={22} /> : <Save />}
        </Button>{' '}
        {remove && <DeleteWithConfirmation onRemove={remove} />}
      </Box>
    </Grid>
  );
};

export default ActionsButtons;
